import "./Contacts.scss";
import SectionTitle from "../../UI/SectionTitle/SectionTitle";
import BorderCircle from "../../UI/BorderCircle/BorderCircle";
import Socials from "../../UI/Socials/Socials";
import ContactsForm from "../../UI/ContactsForm/ContactsForm";

const Contacts = () => {
  return (
    <section className="contacts" id="contacts">
      <div className="container">
        <div className="contacts__wrapper">
          <SectionTitle
            title="Контакты"
            description="В&nbsp;настоящее время я&nbsp;могу работать фрилансером"
          />

          <div className="contacts__content">
            <div className="contacts__left">
              <BorderCircle className="center">
                <h3 className="contacts__label">Отправь мне сообщение</h3>
              </BorderCircle>

              <ContactsForm />
            </div>

            <div className="contacts__right">
              <BorderCircle className="center">
                <h3 className="contacts__label">Напишите в соц-сети</h3>
              </BorderCircle>
              <Socials />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};


export default Contacts;